<template>
  <div>
    <Sidebar></Sidebar>
    <div class="main-content" id="panel">
      <Navbar></Navbar>
      <div class="container-fluid mt--6">
        <router-view></router-view>
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar'
import Navbar from './Navbar'
import Footer from './Footer'
export default {
  name: 'DashboardLayout',
  components: {
    Navbar,
    Sidebar,
    Footer
  }
}
</script>
